define('controllers/perfectsaver',['require','layout'],function (require) {
  "use strict";
  var layout = require("layout");
  return {
    load: function () {
      return layout.initStatic("/fe/templates/about/perfectsaver").then(init);
      function init() {
        layout.hideMatchPlanTemplate();
        $("[data-matchPlanPercentage]").text(
          window.ServerData.Settings.MatchPercentage,
        );
      }
    },
    unload: $.noop,
  };
});

